import { ReactNode } from 'react';
import './dialog.scss';

interface DialogProps {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
  children?: ReactNode;
}

export function Dialog({ open, title, description, onClose, children }: DialogProps) {
  if (!open) return null;

  return (
    <div className="dialog-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="dialog" onClick={(event) => event.stopPropagation()}>
        <div className="dialog__header">
          <h2>{title}</h2>
        </div>
        <div className="dialog__body">
          <p>{description}</p>
          <div className="dialog__actions">{children}</div>
        </div>
      </div>
    </div>
  );
}
